<template>
  <section class="special_course padding_top" v-if="courses != ''">
    <b-container>
      <b-row class="justify-content-center" v-if="title">
        <b-col xl="5">
          <div class="section_tittle">
            <h2 class="text-center">{{ title }}</h2>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          lg="4"
          sm="6"
          class="mt-4"
          v-for="course in courses"
          :key="course.id"
        >

<router-link
                  class="h4 text-white text-decoration-none"
                  :to="{ name: 'SingleCourse', params: { slug: course.slug } }"
                  >
                  
                  <m-c21 :img="course.thumbnail">
            <template #p-1>
             <h3 class="text-white h4">
                <router-link
                  class="h4 text-white text-decoration-none"
                  :to="{ name: 'SingleCourse', params: { slug: course.slug } }"
                  >{{ course.title }}</router-link
                >
              </h3>
               <small
                ><i class="far fa-clock"></i>
                تاریخ انتشار:
                {{ dateConverter(course.created_at) }}</small
              >
            </template>
          </m-c21>
                  
                  </router-link>

          
        </b-col>
      </b-row></b-container
    >
  </section>
</template>  



          </m-c21>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
import { dateConverter } from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
export default {
  name: "NewCourseCard",
  props: ["courses", "title"],
  methods: {
    dateConverter,
  },
  mounted() {},
};
</script>

<style scoped>
.card {
  border: none;
  transition: all 500ms cubic-bezier(0.19, 1, 0.22, 1);
  overflow: hidden;
  border-radius: 20px;
  min-height: 450px;
  box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.2);
  min-height: 100%;
}
.img-card {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  height: 100%;
  width: 100%;
  object-fit: cover;
}
@media (max-width: 768px) {
  .card {
    min-height: 350px;
  }
}
@media (max-width: 420px) {
  .card {
    min-height: 300px;
  }
}
.card:hover {
  transform: scale(1.02);
}
.card .card-meta {
  color: orange;
}
</style>